import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import position from "../../../containers/modules/hr/position";

export default function PositionRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="position"
      index
      element={
        <AccessControl
          name={"Position List"}
          auth={authUser}
          component={position}
        />
      }
    ></Route>
  );
}
